/* ============================================================================
   CRUX EXTRAS — behaviours layered on top of crux-app.js (the verbatim mockup
   interactive layer). Loaded after crux-app.js.
     initDeck3d   : Complex-style 3D fanned card-deck — AUTOPLAYS, pause on hover.
     initStepperAuto : drives Zenith look-stepper to AUTOPLAY + raise neighbour
                       visibility hooks; pauses on hover. (Transition itself is
                       handled by crux-app.js initStepper.)
   Honours prefers-reduced-motion (no autoplay; manual still works).
   ============================================================================ */
(function () {
  'use strict';
  var REDUCE = false;
  try { REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* ---- 3D fanned card-deck ---------------------------------------------- */
  function initDeck3d(scope) {
    $all('[data-deck3d]', scope || document).forEach(function (root) {
      if (root.__cxDeck3d) return; root.__cxDeck3d = true;
      var cards = $all('.cx-deck3d__card', root);
      if (!cards.length) return;
      var countEl = root.querySelector('[data-deck3d-count]');
      var interval = parseInt(root.getAttribute('data-deck3d-autoplay'), 10) || 0;
      var idx = 0, timer = null, paused = false;

      function render() {
        var n = cards.length;
        cards.forEach(function (c, i) {
          var dist = (i - idx + n) % n;
          var cls = 'is-hidden';
          if (dist === 0) cls = 'is-active';
          else if (dist === 1) cls = 'is-next';
          else if (dist === n - 1) cls = 'is-prev';
          else if (dist === 2) cls = 'is-next2';
          else if (dist === n - 2) cls = 'is-prev2';
          c.className = 'cx-deck3d__card ' + cls;
        });
        if (countEl) countEl.textContent = (idx + 1) + ' / ' + n;
      }
      function go(delta) { idx = (idx + delta + cards.length) % cards.length; render(); }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (REDUCE || paused || !interval || cards.length < 2) return; timer = setInterval(function () { go(1); }, interval); }
      function bump() { start(); } // restart-safe after manual interaction

      $all('[data-deck3d-next]', root).forEach(function (b) { on(b, 'click', function () { go(1); bump(); }); });
      $all('[data-deck3d-prev]', root).forEach(function (b) { on(b, 'click', function () { go(-1); bump(); }); });
      cards.forEach(function (c, i) {
        on(c, 'click', function (e) { if (c.classList.contains('is-active')) return; e.preventDefault(); e.stopPropagation(); idx = i; render(); bump(); });
      });
      on(root, 'keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(1); bump(); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); bump(); } });

      var stage = root.querySelector('.cx-deck3d__stage') || root;
      var startX = null;
      on(stage, 'pointerdown', function (e) { startX = e.clientX; });
      on(window, 'pointerup', function (e) { if (startX === null) return; var dx = e.clientX - startX; startX = null; if (Math.abs(dx) > 45) { go(dx < 0 ? 1 : -1); bump(); } });
      on(stage, 'touchstart', function (e) { startX = (e.touches[0] || {}).clientX; }, { passive: true });
      on(stage, 'touchend', function (e) { if (startX === null) return; var dx = (((e.changedTouches[0] || {}).clientX) || startX) - startX; startX = null; if (Math.abs(dx) > 45) { go(dx < 0 ? 1 : -1); bump(); } });

      // pause on hover / focus
      on(root, 'mouseenter', function () { paused = true; stop(); });
      on(root, 'mouseleave', function () { paused = false; start(); });
      on(root, 'focusin', function () { paused = true; stop(); });
      on(root, 'focusout', function () { if (!root.contains(document.activeElement)) { paused = false; start(); } });
      on(document, 'visibilitychange', function () { if (document.hidden) stop(); else start(); });

      render();
      start();
    });
  }

  /* ---- Look-stepper autoplay (transition handled by crux-app.js) -------- */
  function initStepperAuto(scope) {
    $all('[data-stepper]', scope || document).forEach(function (root) {
      if (root.__cxStepAuto) return; root.__cxStepAuto = true;
      var next = root.querySelector('[data-step-next]');
      if (!next) return;
      var raw = root.getAttribute('data-stepper-autoplay');
      var interval = raw === null ? 5000 : parseInt(raw, 10);
      if (!interval || interval <= 0) return; // 0 = off
      var timer = null, paused = false;
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (REDUCE || paused) return; timer = setInterval(function () { next.click(); }, interval); }
      on(root, 'mouseenter', function () { paused = true; stop(); });
      on(root, 'mouseleave', function () { paused = false; start(); });
      on(root, 'focusin', function () { paused = true; stop(); });
      on(root, 'focusout', function () { if (!root.contains(document.activeElement)) { paused = false; start(); } });
      on(document, 'visibilitychange', function () { if (document.hidden) stop(); else start(); });
      // any manual arrow/keyboard re-bases the timer
      $all('[data-step-next],[data-step-prev]', root).forEach(function (b) { on(b, 'click', function () { if (!paused) start(); }); });
      start();
    });
  }

  /* ---- shoppable card: size pick → set the native product-form variant id -- */
  function initShopcards(scope) {
    $all('[data-shopcard]', scope || document).forEach(function (card) {
      if (card.__cxShop) return; card.__cxShop = true;
      var sizes = $all('[data-shopcard-sizes] .cx-size', card);
      if (!sizes.length) return; // single-variant card: form already carries the id
      var idInput = card.querySelector('[data-shopcard-id]');
      var priceEl = card.querySelector('[data-shopcard-price]');
      sizes.forEach(function (btn) {
        on(btn, 'click', function () {
          if (btn.getAttribute('data-available') === 'false') return; // sold out
          sizes.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
          if (idInput) { idInput.value = btn.getAttribute('data-variant-id'); idInput.removeAttribute('disabled'); }
          var p = btn.getAttribute('data-price');
          if (priceEl && p) priceEl.textContent = p;
        });
      });
    });
  }

  /* ---- shop-the-look pins: toggle a product pop, one open at a time ------- */
  function closeAllPins(scope) {
    $all('.cx-pin-wrap.is-open', scope || document).forEach(function (w) {
      w.classList.remove('is-open', 'is-edge-l', 'is-edge-r');
      var b = w.querySelector('[data-pin]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function clampPop(wrap) {
    var pop = wrap.querySelector('[data-pin-pop]');
    if (!pop) return;
    wrap.classList.remove('is-edge-l', 'is-edge-r');
    var r = pop.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var m = 10;
    if (r.left < m) wrap.classList.add('is-edge-l');
    else if (r.right > vw - m) wrap.classList.add('is-edge-r');
  }
  function initLookPins(scope) {
    $all('[data-pin]', scope || document).forEach(function (btn) {
      if (btn.__cxPin) return; btn.__cxPin = true;
      var wrap = btn.closest('.cx-pin-wrap');
      if (!wrap) return;
      var pop = wrap.querySelector('[data-pin-pop]');
      on(btn, 'click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var wasOpen = wrap.classList.contains('is-open');
        closeAllPins();
        if (!wasOpen) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          clampPop(wrap);
        }
      });
      if (pop) on(pop, 'click', function (e) { e.stopPropagation(); }); // keep card clicks inside
    });
  }

  /* ---- Zara-grade quick-add modal: "+" on a card → fetch cx-quickadd → inject -- */
  var qaModal = null, qaContent = null, qaTrigger = null;
  function qaEls() {
    if (!qaModal) {
      qaModal = document.querySelector('[data-cx-qadd-modal]');
      qaContent = qaModal && qaModal.querySelector('[data-cx-qadd-content]');
    }
    return qaModal;
  }
  function qaClose() {
    if (!qaModal || qaModal.hidden) return;
    qaModal.classList.remove('is-open');
    document.documentElement.classList.remove('cx-qadd-lock');
    var t = qaTrigger; qaTrigger = null;
    window.setTimeout(function () { if (qaModal && !qaModal.classList.contains('is-open')) { qaModal.hidden = true; if (qaContent) qaContent.innerHTML = ''; } }, 300);
    if (t && t.focus) { try { t.focus(); } catch (e) {} }
  }
  function qaOpen(handle, trigger) {
    if (!qaEls() || !handle) return;
    qaTrigger = trigger || null;
    qaContent.innerHTML = '<div class="cx-qadd__spin" role="status" aria-label="Loading"><span></span><span></span><span></span></div>';
    qaModal.hidden = false;
    document.documentElement.classList.add('cx-qadd-lock');
    void qaModal.offsetWidth;             // reflow → transition
    qaModal.classList.add('is-open');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=cx-quickadd', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (!qaContent || qaModal.hidden) return;
        qaContent.innerHTML = html;       // <product-form> auto-upgrades on insert
        initShopcards(qaContent);         // bind size buttons
        var f = qaContent.querySelector('.cx-shopcard__close, .cx-size, .cx-shopcard__add');
        if (f && f.focus) { try { f.focus(); } catch (e) {} }
      })
      .catch(function () {
        if (qaContent) qaContent.innerHTML = '<p class="cx-qadd__err">Could not load this item. <a href="' + root + 'products/' + encodeURIComponent(handle) + '">View product</a></p>';
      });
  }
  function initQuickAdd(scope) {
    $all('[data-cx-qadd]', scope || document).forEach(function (btn) {
      if (btn.__cxQA) return; btn.__cxQA = true;
      on(btn, 'click', function (e) { e.preventDefault(); e.stopPropagation(); qaOpen(btn.getAttribute('data-cx-qadd'), btn); });
    });
  }

  function boot(scope) { initDeck3d(scope); initStepperAuto(scope); initShopcards(scope); initLookPins(scope); initQuickAdd(scope); }
  ready(function () {
    boot(document);
    // quick-add modal global wiring (once)
    if (qaEls()) { on(qaModal, 'click', function (e) { if (e.target.closest('[data-cx-qadd-close]')) qaClose(); }); }
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { qaClose(); }); } catch (e) {}
  });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });

  // global close: outside click, Esc (pins + quick-add modal)
  on(document, 'click', function () { closeAllPins(); });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { closeAllPins(); qaClose(); } });
})();
